import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { FaUndo } from "react-icons/fa";
import { IoExitOutline } from "react-icons/io5";
import { API_HOST } from "../api_utils";
import axios from "axios";
import { toast } from "react-toastify";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { Autocomplete, TextField } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

function Collections(props) {
  const { userDataFromStorage, coloredTheme } = props;
  let navigate = useNavigate();

  const singaporeTimezone = "Asia/Singapore";
  const currentDateInSingapore = new Date().toLocaleDateString("en-US", {
    timeZone: singaporeTimezone,
  });
  const [transactionDate, setTransactionDate] = useState(
    formatDate(currentDateInSingapore)
  );

  function formatDate(dateString) {
    const [month, day, year] = dateString.split("/");
    const formattedMonth = month.padStart(2, "0");
    const formattedDay = day.padStart(2, "0");
    return `${year}-${formattedMonth}-${formattedDay}`;
  }
  const [agentName, setAgentName] = useState("");
  const [nickName, setNickName] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20); // Adjust the desired page size
  const [totalPages, setTotalPages] = useState(0);

  // Your existing data and filterData states
  const [data, setData] = useState([]);
  const [agentNameList, setAgentNameList] = useState([]);
  const [nicknameList, setNicknameList] = useState([]);
  const [totalTransaction, setTotalTransaction] = useState(0);
  const [agentNameForApi, setAgentNameForApi] = useState("");
  const [selectedAgentName, setSelectedAgentName] = useState("");

  const [nicknameForApi, setNicknameForApi] = useState("");
  const [selectedCustomerNickname, setSelectedCustomerNickname] = useState("");
  const searchFilterOptionsShowAgent = useRef(true);
  const searchFilterOptionsShowNickname = useRef(true);

  const getAllAgentNames = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/users/agent_name_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setAgentNameList(data);
    }
  };

  const getAllCustomerList = async () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage?.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/customer/get_customer_nickname_list`;

    const { data } = await axios.get(apiUrl, config);
    if (!data.message) {
      setNicknameList(data);
    }
  };

  const fetchData = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      let apiUrl = `${API_HOST}/api/transactions/get_all_transactions?page=${currentPage}&pageSize=${pageSize}`;

      const queryParams = [];
      if (transactionDate) {
        queryParams.push(`transaction_date=${transactionDate}`);
      }

      // if (!transactionDate) {
      //   queryParams.push(`transaction_date=${new Date()}`);
      // }
      if (agentNameForApi) {
        queryParams.push(`agent_name=${agentNameForApi}`);
      }

      if (nicknameForApi) {
        queryParams.push(`customer_nickname=${nicknameForApi}`);
      }

      if (queryParams.length > 0) {
        const queryString = queryParams.join("&");
        apiUrl += `&${queryString}`;
      }

      const { data } = await axios.get(apiUrl, config);

      setData(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDataCount = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      let apiUrl = `${API_HOST}/api/transactions/get_all_transactions_count?page=${currentPage}&pageSize=${pageSize}`;

      const queryParams = [];
      if (transactionDate) {
        queryParams.push(`transaction_date=${transactionDate}`);
      }

      // if (!transactionDate) {
      //   queryParams.push(`transaction_date=${new Date()}`);
      // }
      if (agentNameForApi) {
        queryParams.push(`agent_name=${agentNameForApi}`);
      }

      if (nicknameForApi) {
        queryParams.push(`customer_nickname=${nicknameForApi}`);
      }

      if (queryParams.length > 0) {
        const queryString = queryParams.join("&");
        apiUrl += `&${queryString}`;
      }

      const { data } = await axios.get(apiUrl, config);

      if (data.length > 0) {
        setTotalTransaction(data[0].cash_collected);
      } else {
        setTotalTransaction(0);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchDataCountPage = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      let apiUrl = `${API_HOST}/api/transactions/get_all_transactions_count_page?page=${currentPage}&pageSize=${pageSize}`;

      const queryParams = [];
      if (transactionDate) {
        queryParams.push(`transaction_date=${transactionDate}`);
      }

      // if (!transactionDate) {
      //   queryParams.push(`transaction_date=${new Date()}`);
      // }
      if (agentNameForApi) {
        queryParams.push(`agent_name=${agentNameForApi}`);
      }

      if (nicknameForApi) {
        queryParams.push(`customer_nickname=${nicknameForApi}`);
      }

      if (queryParams.length > 0) {
        const queryString = queryParams.join("&");
        apiUrl += `&${queryString}`;
      }

      const { data } = await axios.get(apiUrl, config);

      if (data.length > 0) {
        setTotalPages(Math.ceil(data[0].totalPages / 20));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllAgentNames();
    getAllCustomerList();
  }, []);

  useEffect(() => {
    fetchData();
    fetchDataCount();
    fetchDataCountPage();
  }, [nicknameForApi, agentNameForApi, transactionDate, currentPage]);

  const handleAgentNameChange = useCallback((e) => {
    setAgentName(e.target.value);
  }, []);

  const filteredAgentOptions = useMemo(() => {
    if (agentName && !selectedAgentName) {
      console.log("here");
      const searchTerm = agentName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      agentNameList.forEach((option) => {
        if (
          option.agent_name &&
          option.agent_name.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.agent_name.toLowerCase().startsWith(searchTerm)",
            option.agent_name.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.agent_name.localeCompare(b.agent_name, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedAgentName) {
        console.log("here agent1111");
        setAgentNameForApi(selectedAgentName);
        setSelectedAgentName("");

        searchFilterOptionsShowAgent.current = false;
      } else {
        console.log("here agent222");
        searchFilterOptionsShowAgent.current = true;
      }

      return [];
    }
  }, [agentName, selectedAgentName]);

  const handleCustomerNicknameChange = useCallback((e) => {
    setNickName(e.target.value);
  }, []);

  const filteredNicknameOptions = useMemo(() => {
    if (nickName && !selectedCustomerNickname) {
      console.log("here");
      const searchTerm = nickName.toLowerCase();
      const optionsStartingWithSearchTerm = [];

      console.log("searchTerm", searchTerm);

      nicknameList.forEach((option) => {
        if (
          option.nickname &&
          option.nickname.toLowerCase().startsWith(searchTerm)
        ) {
          console.log(
            "option.nickname.toLowerCase().startsWith(searchTerm)",
            option.nickname.toLowerCase().startsWith(searchTerm)
          );
          optionsStartingWithSearchTerm.push(option);
        }
      });

      optionsStartingWithSearchTerm.sort((a, b) =>
        a.nickname.localeCompare(b.nickname, undefined, {
          sensitivity: "base",
        })
      );

      console.log(
        "optionsStartingWithSearchTerm",
        optionsStartingWithSearchTerm
      );

      // setAgentLastName("");

      return optionsStartingWithSearchTerm;
    } else {
      console.log("here agent");
      if (selectedCustomerNickname) {
        console.log("here agent1111");
        setNicknameForApi(selectedCustomerNickname);
        setSelectedCustomerNickname("");

        searchFilterOptionsShowNickname.current = false;
      } else {
        console.log("here agent222");
        searchFilterOptionsShowNickname.current = true;
      }

      return [];
    }
  }, [nickName, selectedCustomerNickname]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[2rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <p className="text-gray-800 text-[1.8rem] tracking-wider">
        Collections Report
      </p>

      {/* search field */}
      <div className="bg-white mt-[2%]">
        <p
          style={{ backgroundColor: coloredTheme }}
          className=" text-white px-[0.5rem] py-[1rem] ">
          Search Fields
        </p>
        <div className="px-[0.5rem] pb-[1rem] mt-2">
          <div className="md:flex justify-start items-center ">
            <p className="w-[25rem]">Transaction Date</p>
            <input
              value={transactionDate}
              onChange={(e) => setTransactionDate(e.target.value)}
              type="date"
              className="outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0"
            />
          </div>
          {userDataFromStorage?.user_role === "agent" ||
          userDataFromStorage?.user_role === "senior_agent" ? (
            ""
          ) : (
            <div className="relative md:flex justify-start items-center mt-6">
              <p className="w-[30%]">Agent Last Name</p>
              <input
                type="text"
                value={agentName}
                placeholder="Enter Agent Last Name"
                onInput={(e) => {
                  console.log("e.target::::::", e.target.value);
                  handleAgentNameChange(e);
                }}
                className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
              />
              {filteredAgentOptions.length > 0 && (
                <div
                  className={
                    searchFilterOptionsShowAgent.current === true
                      ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                      : "hidden"
                  }>
                  {filteredAgentOptions.map((option, index) => (
                    <div
                      className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                      onClick={() => {
                        console.log("option.agent_name::", option.agent_name);
                        setAgentName(option.agent_name);
                        setSelectedAgentName(option.agent_name);
                      }}
                      key={index}>
                      {option.agent_name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          <div className="relative md:flex justify-start items-center mt-6">
            <p className="w-[30%]">Customer Nickname</p>
            <input
              type="text"
              value={nickName}
              placeholder="Enter Customer Nickname"
              onInput={(e) => {
                console.log("e.target::::::", e.target.value);
                handleCustomerNicknameChange(e);
              }}
              className="outline-none  border border-gray-300 rounded-lg  w-[70%]   p-[0.8rem] "
            />
            {filteredNicknameOptions.length > 0 && (
              <div
                className={
                  searchFilterOptionsShowNickname.current
                    ? "absolute 2xl:top-[4rem] lg:top-[4rem] lg:max-h-[12rem] xl:top-[4rem] xl:max-h-[12rem] 2xl:max-h-[13rem] overflow-y-scroll w-[100%]  rounded-lg shadow-xl bg-white z-10"
                    : "hidden"
                }>
                {filteredNicknameOptions.map((option, index) => (
                  <div
                    className="bg-white cursor-pointer p-[0.5rem] hover:bg-cyan-200 transition duration-[0.3s]"
                    onClick={() => {
                      setSelectedCustomerNickname(option.nickname);
                      setNickName(option.nickname);
                    }}
                    key={index}>
                    {option.nickname}
                  </div>
                ))}
              </div>
            )}
          </div>
          {/* <div className='md:flex justify-start items-center mt-6'>
            <p className='w-[25rem]'>Show Cash Dispursed</p>
            <div className='mt-2 md:mt-0'>
              <input type="radio" id="Yes" />
              <label className='ml-1 mr-4' htmlFor='Yes'>Yes</label>
              <input type="radio" id="No" />
              <label className='ml-1' htmlFor='No'>No</label>
            </div>
          </div> */}
          <div className="flex justify-start items-center space-x-2 mt-6">
            <button
              onClick={() => {
                setNickName("");
                setAgentName("");
                setAgentNameForApi("");
                setNicknameForApi("");
              }}
              style={{ backgroundColor: coloredTheme }}
              className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem]  text-white">
              <FaUndo />
              <p>Reset Search Fields</p>
            </button>
            <button
              onClick={() => fetchData()}
              style={{ backgroundColor: coloredTheme }}
              className="flex justify-center items-center  rounded space-x-2 transition duration-[0.6s] px-[1rem] py-[0.5rem] text-white">
              <FiSearch />
              <p>Search</p>
            </button>
          </div>
        </div>
      </div>

      <div className="mt-8 overflow-scroll">
        <p
          style={{ backgroundColor: coloredTheme }}
          className=" p-[1rem] md:w-[100%] w-[300%] text-white">
          Total Payments Collected MYR {totalTransaction}
        </p>
        <table className="md:w-[100%] w-[300%]">
          <thead className="h-[6vh]">
            <tr>
              <th className="text-center">Manager</th>
              {userDataFromStorage.user_role === "admin" ||
              userDataFromStorage.user_role === "manager" ? (
                <th className="text-center">Agent</th>
              ) : (
                ""
              )}
              <th className="text-center">Entered By</th>
              <th className="text-center">Customer Nickname</th>
              <th className="text-center">Loan Number</th>
              <th className="text-center">Transaction Amount</th>
              <th className="text-center">Transaction Date</th>
            </tr>
          </thead>
          <tbody>
            {data.length
              ? data.map((x, index) => {
                  const date = new Date(x.transactionDate);
                  const day = date.getDate();
                  const month = date.getMonth() + 1;
                  const year = date.getFullYear();
                  return (
                    <tr
                      className={
                        index % 2 === 0
                          ? "bg-white border border-gray-700 "
                          : "border border-gray-700 bg-sky-100"
                      }
                      key={index}>
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                        {x.manager_name}
                      </td>
                      {userDataFromStorage.user_role === "admin" ||
                      userDataFromStorage.user_role === "manager" ? (
                        <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                          {x.agent_name}
                        </td>
                      ) : (
                        ""
                      )}
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                        {x.entered_by}
                      </td>
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                        {x.customer_nickname}
                      </td>
                      {userDataFromStorage.user_role === "admin" ? (
                        <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                          <p>Company Loan Number : {x.loan_number}</p>
                          <p>Agent Loan Number : {x.agent_loan}</p>
                        </td>
                      ) : (
                        <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                          {x.agent_loan}
                        </td>
                      )}
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                        MYR {x.transaction_amount}
                      </td>
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">{`${day}/${month}/${year}`}</td>
                    </tr>
                  );
                })
              : ""}
          </tbody>
        </table>

        <div className=" flex justify-end items-center mt-[2%] px-[0.8rem]">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(event, newPage) => setCurrentPage(newPage)}
              variant="outlined"
              shape="rounded"
            />
          </Stack>
        </div>

        <div className="mt-6">
          <button
            onClick={() => navigate("/home")}
            style={{ backgroundColor: coloredTheme }}
            className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white">
            <IoExitOutline />
            <p>Exit</p>
          </button>
        </div>
      </div>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default Collections;
